import styled from "styled-components";

export const HContainer = styled.div`
    width: 100%;
    /* min-height: 100vh; */
    height: fit-content;
    display: flex;
    justify-content: center;
    align-items: center;
    /* position: relative;
    top: 65px; */
`